/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient
 */
export interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient {
    /**
     * 
     */
    patient_id?: string;
    /**
     * 
     */
    type?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientTypeEnum;
    /**
     * 
     */
    details_push_date?: string;
    /**
     * 
     */
    details_extraction_date?: string;
    /**
     * 
     */
    is_extracting_details?: boolean;
    /**
     * 
     */
    is_screener_document_upload_in_progress?: boolean;
    /**
     * 
     */
    is_additional_document_upload_in_progress?: boolean;
    /**
     * 
     */
    is_generated_document_upload_in_progress?: boolean;
}


/**
 * @export
 */
export const FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientTypeEnum = {
    Pcc: 'PCC',
    MatrixCare: 'MATRIX_CARE',
    Hchb: 'HCHB',
    MatrixCareHomeHealth: 'MATRIX_CARE_HOME_HEALTH',
    Kinnser: 'KINNSER',
} as const;
export type FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientTypeEnum = typeof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientTypeEnum[keyof typeof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientTypeEnum];


/**
 * Check if a given object implements the FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient interface.
 */
export function instanceOfFindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient(value: object): value is FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient {
    return true;
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientFromJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientFromJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient {
    if (json == null) {
        return json;
    }
    return {
        
        'patient_id': json['patient_id'] == null ? undefined : json['patient_id'],
        'type': json['type'] == null ? undefined : json['type'],
        'details_push_date': json['details_push_date'] == null ? undefined : json['details_push_date'],
        'details_extraction_date': json['details_extraction_date'] == null ? undefined : json['details_extraction_date'],
        'is_extracting_details': json['is_extracting_details'] == null ? undefined : json['is_extracting_details'],
        'is_screener_document_upload_in_progress': json['is_screener_document_upload_in_progress'] == null ? undefined : json['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': json['is_additional_document_upload_in_progress'] == null ? undefined : json['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': json['is_generated_document_upload_in_progress'] == null ? undefined : json['is_generated_document_upload_in_progress'],
    };
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientToJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientToJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientToJSONTyped(value?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient_id': value['patient_id'],
        'type': value['type'],
        'details_push_date': value['details_push_date'],
        'details_extraction_date': value['details_extraction_date'],
        'is_extracting_details': value['is_extracting_details'],
        'is_screener_document_upload_in_progress': value['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': value['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': value['is_generated_document_upload_in_progress'],
    };
}

